// extracted by mini-css-extract-plugin
export default {"guides":"Access_guides__gusot","avatar":"Access_avatar__2A+yU","banner":"Access_banner__m3ew4"};